export default "__VITE_ASSET__TPC0y0qg__"